import { createContext, useContext } from 'react';

import type { TextSize } from '../../core/types/text-size.js';
import { DEFAULT_TEXT_SIZE } from '../constants.js';

export const TextSizeContext = createContext<TextSize>(DEFAULT_TEXT_SIZE);

export const useTextSize = () => useContext(TextSizeContext);

TextSizeContext['displayName'] = 'TextSizeContext';
